import { Injectable } from '@angular/core';
import { UnimportedItem } from '../common/models/unimportedItem';
import { UnimportedItemGroup } from '../common/models/unimportedItemGroup';

@Injectable({ providedIn: 'root' })
export class UnimportedItemGroupService {
  constructor() {}

  private mapUnimportedItemsToItemGroup(items: UnimportedItem[]): Map<string, UnimportedItemGroup> {
    const menuItemGroups = new Map<string, UnimportedItemGroup>();
    items.forEach((item) => {
      let itemGroup = menuItemGroups.get(item.externalItemNumber);
      itemGroup = this.upsertItemGroup(item, itemGroup);
      menuItemGroups.set(item.externalItemNumber ?? item.commerceItemNumber, itemGroup);
    });

    return menuItemGroups;
  }

  private upsertItemGroup(item: UnimportedItem, itemGroup: UnimportedItemGroup | undefined): UnimportedItemGroup {
    if (itemGroup !== undefined) {
      itemGroup.isExternalItemNumberGroup = true;
      itemGroup.unimportedItems.push(item);
      itemGroup.itemNumber = item.externalItemNumber;
    } else {
      itemGroup = {
        isExternalItemNumberGroup: false,
        itemNumber: item.externalItemNumber ?? item.commerceItemNumber,
        unimportedItems: [item],
      } as UnimportedItemGroup;
    }
    return itemGroup;
  }

  private transformItemGroupsMapToItemGroupsArray(
    menuItemGroups: Map<string, UnimportedItemGroup>,
  ): UnimportedItemGroup[] {
    const filteredItemGroups = Array.from(menuItemGroups, ([name, value]) => value);
    filteredItemGroups.sort((a, b) => Number.parseInt(a.itemNumber) - Number.parseInt(b.itemNumber));
    return filteredItemGroups;
  }

  public mapUnimportedItemsToItemGroupArray(items: UnimportedItem[]): UnimportedItemGroup[] {
    const menuItemGroups = this.mapUnimportedItemsToItemGroup(items);
    const itemGroupArray = this.transformItemGroupsMapToItemGroupsArray(menuItemGroups);
    return itemGroupArray;
  }
}
